module.exports = __webpack_public_path__ + "img/scene-icon-5.c1a20daf.png";